import { StyleSheet } from 'react-native'


const styles = StyleSheet.create({
  webView: {
    // paddingBottom: 32,
  },
  detailsContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
    paddingTop: 24,
  },
  lottieWrapper: {
    height: '100%',
    paddingHorizontal: 16,
    paddingVertical: 32,
    marginBottom: 32,
    justifyContent: 'center',
    alignItems: 'center',
  },
  lottie: {
    width: 120,
    height: 120,
    marginLeft: 0
  }

})

export default styles
